import React from 'react'

import AdminDrawer from '../../components/AdminDrawer'
import NationalNFSeSettingsComponent from '../../components/NationalNFSeSettings'

const NationalNFSeSettings = () => {
    return <AdminDrawer child={<NationalNFSeSettingsComponent />} />
}

export default NationalNFSeSettings